/** Returns the permission slug required for forcing immediate takeover of a fill-out lock. */
export function getForceTakeoverPermissionSlugForRevisionKind(kind: string): string {
  return kind === 'revision' ? 'force-takeover-revisions' : 'force-takeover-forms';
}
